import styled from "@emotion/styled";
import { Accordion, Button, FormControlLabel, RadioGroup } from "@mui/material";

export const BillToSettingsPageHeader = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	padding: "20px 32px",
	backgroundColor: theme.project.colors.backgroundColors.main,
	h1: {
		...theme.project.typography.heading.h4,
		color: theme.project.colors.fontColors.main,
		margin: 0
	},
	button: {
		alignItems: "center"
	},
	[theme.breakpoints.down("md")]: {
		alignItems: "flex-start",
		flexDirection: "column",
		gap: theme.project.layout.gap.large
	}
}));

export const BillToSettingsContainer = styled.div(({ theme }) => ({
	padding: 20,
	margin: "12px",
	border: theme.project.borders.presets.outline,
	borderWidth: "1px",
	backgroundColor: theme.project.colors.backgroundColors.main,
	position: "relative",
	[theme.breakpoints.down("lg")]: {
		padding: 16,
		paddingBottom: 150
	}
}));

export const BillToSettingsCardHeader = styled.span(({ theme }) => ({
	...theme.project.typography.subtitle,
	color: theme.project.colors.fontColors.secondary,
	fontWeight: 400,
	letterSpacing: "1px",
	fontSize: "16px"
}));

export const AcknowledgementConfigCard = styled.div(({ theme }) => ({
	position: "relative",
	margin: "16px 0 0 0",
	border: theme.project.borders.presets.outline,
	borderWidth: "1px",
	backgroundColor: theme.project.colors.backgroundColors.card,
	color: theme.project.colors.fontColors.secondary,
	minWidth: 0,
	[theme.breakpoints.down("md")]: {
		paddingBottom: 25
	}
}));

export const DefaultSettingsAccordion = styled(Accordion)(({ theme }) => ({
	"& .MuiAccordionSummary-content": {
		...theme.project.typography.overline,
		margin: "9px 0"
	},
	boxShadow: "none",
	position: "initial",
	border: "1px solid " + theme.palette.grey[300],
	marginTop: "16px !important",
	"& .MuiAccordionDetails-root": {
		padding: 0
	},
	"& .Mui-expanded": {
		margin: "0px !important"
	}
}));

export const RadioGroupStyled = styled(RadioGroup)({
	flexDirection: "column",
	display: "flex",
	margin: 0
});

export const Header = styled.div({
	gridArea: "header",
	display: "flex"
});

export const DeleteButton = styled(Button)(({ theme }) => ({
	top: 0,
	right: 0,
	position: "absolute",
	gridArea: "delete",
	margin: "16px 0 5px 0",
	alignItems: "center",
	justifySelf: "end",
	color: theme.project.colors.primaryColors.main,
	fontWeight: 500,
	minWidth: "0px",
	svg: {
		height: "20px",
		width: "20px",
		marginRight: "10px"
	},

	"span:first-of-type": {
		marginRight: "10px",
		fontSize: "16px"
	},
	[theme.breakpoints.down("md")]: {
		justifySelf: "end",
		bottom: 0,
		top: "auto"
	}
}));

export const EmailAddressFieldWrapper = styled.div(({ theme }) => ({
	display: "inline-flex",
	gridArea: "fields",
	gap: 16,
	margin: "0 16px 16px",
	width: "40%",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		width: "90%"
	}
}));

export const AcknowledgementCheckbox = styled(FormControlLabel)({
	display: "flex",
	alignItems: "flex-start"
});

export const AcknowledgementCheckboxText = styled.div({
	"& > div:last-of-type": {
		fontStyle: "italic"
	},
	padding: "8px 0"
});

export const BillToSettingsButtonRow = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	gap: "16px",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		width: "100%",
		margin: "16px 0 0 0"
	}
}));

export const BillToSettingsButtonGroup = styled.div(({ theme }) => ({
	display: "flex",
	gap: "16px",

	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		width: "100%"
	}
}));

export const BillToSettingsButton = styled(Button)(({ theme }) => ({
	margin: "16px 0 0 0",

	[theme.breakpoints.down("md")]: {
		width: "100%",
		margin: 0
	}
}));

export const BottomStickyRow = styled.div(({ theme }) => ({
	position: "fixed",
	left: 0,
	right: 0,
	bottom: 0,

	backgroundColor: theme.project.colors.backgroundColors.main,
	border: theme.project.borders.presets.outline,

	padding: "16px 16px",

	zIndex: 5,
	marginLeft: 260,
	marginRight: 12,
	[theme.breakpoints.down("lg")]: {
		margin: 12
	}
}));

export const BillToSettingsErrorBoxWrapper = styled.div(({ theme }) => ({
	width: "100%",
	height: "100vh",
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	backgroundColor: theme.project.colors.backgroundColors.main
}));

export const WarningBoxContainer = styled.div({
	paddingTop: "16px"
});

export const AcknowledgementConfigCardHeader = styled.div({
	margin: "16px",
	display: "flex",
	justifyContent: "space-between"
});

export const SkeletonButtonRow = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	gap: "16px",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		width: "100%",
		margin: "16px 0 0 0"
	}
}));
